module.exports = __webpack_public_path__ + "img/author-placeholder.17938b4.svg";